<div class="report-error-dialog-container color-excemption">
  <h2 class="headline-text">Meld fra om feil til forhandlersupport</h2>
  <div class="report-error-dialog-content">
    <app-ice-alert iconWidth="1.5rem" type="info" [iconName]="IconNames.ice_chat">
      <div>
        <b>Tlf 21 00 00 00 - tastevalg 9</b>
      </div>
    </app-ice-alert>
  </div>
</div>
